import React, { useState } from 'react';
import { Info } from 'lucide-react';

export interface InfoTooltipProps {
  /** Content to display inside the tooltip/popover */
  content: React.ReactNode;
}

/**
 * A simple info icon that toggles a tooltip/popover with explanatory content.
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({ content }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="p-1 ml-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 focus:outline-none"
        aria-label="More info"
      >
        <Info className="w-4 h-4" />
      </button>
      {open && (
        <div className="absolute right-0 z-10 w-64 p-3 mt-1 text-sm text-gray-700 bg-white border border-gray-200 rounded-lg shadow-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200">
          {content}
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;